//File to store contants of the application like Url, port no, etc.

//const DOMAIN = 'http://localhost:'
//const DOMAIN = 'http://116.203.237.65:' ;
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Select, styled } from '@mui/material';
import { Theme } from '@mui/material/styles';

const DOMAIN = window.location.href.includes("localhost") ?
  'http://localhost' :
  'https://brixpro.inuaid.com';

const PORT = window.location.href.includes("localhost") ?
  ":8000" :
  "";

//const PORT = 8080;

var BASEURL = DOMAIN + PORT + "/api";

var IMAGEURL = DOMAIN + PORT ;
const ARROW = '>';
const SIGN_FONT = 'Vladimir Script';
const FEATURE_NAMES = ["Select All", "Daily Logs", "Work Order", "Service Tickets", "Punch Lists", "To-do lists", "Inspections", "Safety Tips", "Vehicle Logs"]
const STATUS = ["Select All", "Pending", "In progress", "Completed", "Delayed"]

const AUTOFILL_STYLES = (theme: Theme) => ({
  '& input:-webkit-autofill': {
    '-webkit-text-fill-color': theme.palette.text.primary, // Use primary text color from the theme
    '-webkit-box-shadow': `0 0 0 30px ${theme.palette.background.default} inset`, // Use the background color from the theme for autofill
  },
});

const StyledSelect = styled(Select)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main, // Button background color
  color: '#000', // Button text color
  fontSize: '0.875rem', // Button font size (14px)
  fontWeight: 600, // Light bold
  borderRadius: '4px', // Same as button
  padding: '6px 8px', // Similar padding as button
  textAlign: 'center', // Center align text
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none', // Remove default border
  },
  '& .MuiSelect-select': {
    padding: '8px 16px', // Match padding to make it look like a button
  },
  '&:hover': {
    backgroundColor: theme.palette.primary.dark, // Darker background on hover
  },
}));

const FONT_SIZE = 30


const videoUrls = [
  'https://www.youtube.com/embed/9s2oYUy_cVY', // Rick Astley - Never Gonna Give You Up (Rickroll)
  'https://www.youtube.com/embed/zOjov-2OZ0E', // PSY - GANGNAM STYLE
  'https://www.youtube.com/embed/OWJCfOvochA',
  // Add more YouTube embed URLs here
];

const videoTitles = [
  "How to create new project activity",
  "How to view/update the project schedule",
  "How to capture and publish image",
  // Add more titles as needed
];

//const STRIPE_PK_KEY = 'pk_live_51P0ufVJXR77vB6QT6p2YBMYLgZMBHYNevKIqU0zlKksIrao47RdKPFY1dh3huONP7dW8QBfs5QDa2Vbj7bCM9bP80074tsSAVk'
const STRIPE_PK_KEY ='pk_test_51P0ufVJXR77vB6QTLiM5OMQdbmFe2j9d3teupxxmejoctZ1IPqOKMjL7SyCNR7Kw0gcWaX71fBiRyaKPcrnjbX7o00ZuXTjuY2'

interface ConfirmationDialogProps {
  open: boolean;
  handleClose: () => void;
  handleConfirm: (event: any) => void;
  message: string;
  title: string;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({ open, handleClose, handleConfirm, message, title }) => (
  <Dialog
    open={open}
    onClose={handleClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        {message}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose} variant="contained" color="primary" sx={{ mr: 1 }}>
        No
      </Button>
      <Button onClick={handleConfirm} variant="contained" color="primary" sx={{ mr: 1 }}>
        Yes
      </Button>
    </DialogActions>
  </Dialog>
);

export { BASEURL, ARROW, IMAGEURL, SIGN_FONT, videoUrls, videoTitles, STATUS, FEATURE_NAMES, FONT_SIZE, AUTOFILL_STYLES, StyledSelect, ConfirmationDialog,STRIPE_PK_KEY }



